import { ofType } from "redux-observable"
import { EMPTY, catchError, mergeMap } from "rxjs"
import { isError } from "../../helpers/Error"
import { CONTACT_ACTION_TYPES } from "../actions/types"
import Contact from "../models/contact"
import {
    deleteFailed,
    fetchContactFormSuccess,
    fetchSupplier,
    setDuplicatedContactsByEmail,
    setDuplicatedContactsByPhoneNumber
} from "../reducers/reducer"
import { ContactFormService } from "../services/ContactFormService"
import { CheckForDuplicatePayload, UpsertContact } from "./types"


export const checkForDuplicateEmailEpic = (action$) => {
    return action$.pipe(
        ofType(CONTACT_ACTION_TYPES.CHECK_DUPLICATED_EMAIL),
        mergeMap((payload:CheckForDuplicatePayload) => {
            return ContactFormService.CheckForDuplicate("emailKeyword", payload.value, payload.contactId).then(res => {
                if (res && !res.error) {
                    return setDuplicatedContactsByEmail(res)
                }
                return EMPTY
            })
        }),
        catchError(() => EMPTY)
    )
}

export const checkForDuplicatePhoneNumberEpic = (action$) => {
    return action$.pipe(
        ofType(CONTACT_ACTION_TYPES.CHECK_DUPLICATED_PHONE_NUMBER),
        mergeMap((payload:CheckForDuplicatePayload) => {
            return ContactFormService.CheckForDuplicate("phoneNumberKeywordCheckDup", payload.value, payload.contactId).then(res => {
                if (res && !res.error) {
                    return setDuplicatedContactsByPhoneNumber(res)
                }
                return EMPTY
            })
        }),
        catchError(() => EMPTY)
    )
}

export const fetchEpic = (action$) => {
    return action$.pipe(
        ofType(CONTACT_ACTION_TYPES.FETCH_CONTACT),
        mergeMap((payload: { contactId: string }) => {
            return ContactFormService.Get(payload.contactId)
                .then(res => {
                    if (isError(res)) {
                        window.location.href = "/suppliers/listing"
                    }
                    
                    const contactFromResult=new Contact(res) 
                    return fetchContactFormSuccess(contactFromResult.getDto())
                    
                })
        }),
        catchError(() => EMPTY)
    )
}


export const fetchSupplierEpic = (action$) => {
    return action$.pipe(
        ofType(fetchSupplier.type),
        mergeMap(({ payload }) => {
            return ContactFormService.Get(payload)
                .then(res => {
                    if (isError(res)) {
                        window.location.href = "/suppliers/listing"
                    }
                    
                    const contactFromResult=new Contact(res) 
                    return fetchContactFormSuccess(contactFromResult.getDto())
                    
                })
        }),
        catchError(() => EMPTY)
    )
}

export const patchEpic = (action$) => {
    return action$.pipe(
        ofType(CONTACT_ACTION_TYPES.UPSERT_CONTACT),
        mergeMap(( payload:UpsertContact ) => {
            return ContactFormService.SaveContact(payload.contactId, payload.companyIdentifier,payload.payload,payload.contactType)
                .then(res => {
                    if (res && !res.error) {
                        if (payload.contactId) {
                            window.location.href = `/suppliers/${payload.contactId}/details`
                        } else {
                            window.location.href = "/suppliers/listing"
                        }
                    }
                })
        }),
        catchError(() => EMPTY)
    )
}

export const deleteEpic = (action$) => {
    return action$.pipe(
        ofType(CONTACT_ACTION_TYPES.DELETE_CONTACT),
        mergeMap((payload: UpsertContact) => {
            return ContactFormService.DeleteContact(payload.contactId)
                .then(res => {
                    if (res.error){
                        return deleteFailed(res.error.message)
                    }
                    window.location.href = "/suppliers/listing"
                })
        }),
        catchError(() => EMPTY)
    )
}



// WEBPACK FOOTER //
// ./src/state/contact/epics/epics.ts